import React from "react";
import { SmallNavDropdown } from "./SmallNavDropdown";
import { FullNavDropdown } from "./FullNavDropdown";
import { NavData } from "./NavItem";
import { cn } from "@/helpers/utils";

export interface NavDropdownProps {
  link: NavData;
}

const NavDropdown = ({ link }: NavDropdownProps) => {
  if (link.type === "submenu") {
    const isMegaMenu =
      link.title === "Shop All" ||
      link.title === "Dish" ||
      link.title === "Laundry";
    if (isMegaMenu) {
      return <FullNavDropdown links={link.links} />;
    } else {
      if (link.title === "Why Dropps") {
        return (
          <SmallNavDropdown
            className="right-28 -mt-0.5"
            link={link}
            id="why-dropps-dropdown"
          />
        );
      }
      if (link.title === "Account") {
        const isLoggedIn = link.links.length > 1;
        return (
          <SmallNavDropdown
            className={cn("-mt-0.5", isLoggedIn ? "right-4" : "right-14")}
            link={link}
            id="nav-account-dropdown"
          />
        );
      }
      return null;
    }
  }
  return null;
};

export { NavDropdown };
